import React from 'react'
import { Helmet } from 'react-helmet-async'
import ContentfulQuery from '#src/containers/Contentful'
import config from '#src/config'

interface OpenGraphProps {
  slug?: string | null
  canonicalPath?: string
  type?: string
}

interface OpenGraphTemplateContentfulResponse {
  loading: boolean
  content: {
    title?: string
    description?: string
    image?: {
      imageUrl: string
    }
  }
}

const OpenGraphTemplate: React.SFC<OpenGraphProps> = ({
  slug,
  canonicalPath,
  type = 'website'
}) => {
  return (
    <ContentfulQuery template="openGraphTemplate" variation={slug ? slug : 'default'}>
      {({ content }: OpenGraphTemplateContentfulResponse) => {
        if (content) {
          const { title, description, image } = content

          return (
            <Helmet>
              <meta
                property="og:url"
                content={`${config.get('openGraph.url')}${canonicalPath ? canonicalPath : ''}`}
              />

              {type && <meta property="og:type" content={type} />}
              {image && (
                <meta property="og:image" content={`${image.imageUrl}?auto=compress,format`} />
              )}
              {image && <meta property="twitter:card" content={image.imageUrl} />}
              {title && <meta property="og:title" content={title} />}
              {description && <meta property="og:description" content={description} />}
              {description && <meta property="description" content={description} />}
            </Helmet>
          )
        }

        return null
      }}
    </ContentfulQuery>
  )
}

export default OpenGraphTemplate
